import { ReferralType } from '~/types/referral';
import type { SpecialtyFormConfig } from '~/types/specialty';
import { DentalSpecialty, DisplayType } from '~/types/specialty';

/**
 * Configuration for Endodontic specialty referral form
 */
export const endodonticConfig: SpecialtyFormConfig = {
  specialty: DentalSpecialty.ENDODONTIC,
  displayName: 'Endodontic',
  requiresToothSelection: true,
  referralTypes: [
    ReferralType.URGENT,
    ReferralType.ROUTINE,
    ReferralType.SYMPTOMATIC,
    ReferralType.ELECTIVE,
    ReferralType.CONSULTATION,
  ],
  diagnosisOptions: [
    {
      name: 'Pulpal Diagnosis',
      displayType: DisplayType.DROPDOWN,
      options: [
        'Normal Pulp',
        'Reversible Pulpitis',
        'Irreversible Pulpitis',
        'Symptomatic Irreversible Pulpitis',
        'Asymptomatic Irreversible Pulpitis',
        'Pulp Necrosis',
        'Previously Treated',
        'Previously Initiated',
      ],
    },
    {
      name: 'Periodontal Diagnosis',
      displayType: DisplayType.DROPDOWN,
      options: [
        'Normal Periapical Tissue',
        'Normal Apical Tissue',
        'Symptomatic Apical Periodontitis',
        'Chronic Apical Periodontitis',
        'Chronic Apical Abscess',
        'Acute Apical Abscess',
        'Condensing Osteitis',
      ],
    },
  ],
  treatmentQuestions: [
    {
      name: 'Restore Access',
      displayType: DisplayType.DROPDOWN,
      options: ['Temporary Restoration', 'Permanent Restoration'],
    },
    {
      name: 'Tooth is Non Restorable',
      displayType: DisplayType.DROPDOWN,
      options: ['Refer Back', 'Please Manage'],
    },
  ],
};
